import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Music } from './pages/Music';
import { Guestbook } from './pages/Guestbook';
import { Tour } from './pages/Tour';
import { Shop } from './pages/Shop';
import { Subscribers } from './pages/Subscribers';
function AppShell() {
  return <div className="min-h-screen bg-[#f5f5f5] text-black flex flex-col" data-id="element-0">
      <div className="flex-1" data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/music" element={<Music data-id="element-6" />} data-id="element-5" />
          <Route path="/tour" element={<Tour data-id="element-8" />} data-id="element-7" />
          <Route path="/shop" element={<Shop data-id="element-10" />} data-id="element-9" />
          <Route path="/guestbook" element={<Guestbook data-id="element-12" />} data-id="element-11" />
          <Route path="/subscribers" element={<Subscribers data-id="element-14" />} data-id="element-13" />
        </Routes>
      </div>
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-15">
      <AppShell data-id="element-16" />
    </BrowserRouter>;
}